import ACTION_CONSTANTS from '../../constants/actionConstants';
import { RECORD_BINDER_STATUS } from '../../constants/AppConstants';

export const initialState = {
  recordBinders: [],
  currentRecordBinder: null,
  isLoading: false,
  error: null,
  recordHistory: [],
  isHistoryLoading: false,
  recordHistoryDetails: null,
  isHistoryDetailsLoading: false,
  isSubmitting: false,
  success: false,
  isUpdating: false,
  updateSuccess: false,
  isDeleting: false,
  deleteSuccess: false,
  query: '',
  filter: {
    status: RECORD_BINDER_STATUS.ACTIVE,
    startDate: null,
    endDate: null,
    sort: false,
  },
  historyFilter: {
    startDate: null,
    endDate: null,
  },
  binRecordBinders: [],
  binQuery: '',
  isBinLoading: false,
  binError: null,
  attachmentUploads: {},
};

const binInitialState = {
  binRecordBinders: [],
  binQuery: '',
  isBinLoading: false,
  binError: null,
};

export default function recordBinderReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.GET_RECORD_BINDERS_REQUESTED:
      return {
        ...state,
        isLoading: action.payload?.loading !== false,
        error: null,
      };

    case ACTION_CONSTANTS.GET_RECORD_BINDERS_SUCCESS:
      return {
        ...state,
        recordBinders: action.payload,
        isLoading: false,
        error: null,
      };

    case ACTION_CONSTANTS.GET_RECORD_BINDERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ACTION_CONSTANTS.SET_CURRENT_RECORD_BINDER:
      return {
        ...state,
        currentRecordBinder: action.payload,
      };

    case ACTION_CONSTANTS.RESET_RECORD_BINDER_PROPS:
      return initialState;

    case ACTION_CONSTANTS.GET_BIN_RECORD_BINDERS_REQUESTED:
      return {
        ...state,
        isBinLoading: action.payload?.loading !== false,
        binError: null,
      };

    case ACTION_CONSTANTS.GET_BIN_RECORD_BINDERS_SUCCESS:
      return {
        ...state,
        binRecordBinders: action.payload,
        isBinLoading: false,
        binError: null,
      };

    case ACTION_CONSTANTS.GET_BIN_RECORD_BINDERS_FAILURE:
      return {
        ...state,
        isBinLoading: false,
        binError: action.payload,
      };

    case ACTION_CONSTANTS.SEARCH_BIN_RECORD_BINDERS:
      return {
        ...state,
        binQuery: action.payload || '',
      };

    case ACTION_CONSTANTS.RESET_RECORD_BINDER_BIN_PROPS:
      return {
        ...state,
        ...binInitialState,
      };

    case ACTION_CONSTANTS.RESET_RECORD_BINDER_ERROR_PROPS:
      return {
        ...state,
        error: null,
      };

    case ACTION_CONSTANTS.SEARCH_RECORD_BINDERS:
      return {
        ...state,
        query: action.payload || '',
      };

    case ACTION_CONSTANTS.FILTER_RECORD_BINDERS:
      return {
        ...state,
        filter: action.payload || {
          status: RECORD_BINDER_STATUS.ACTIVE,
          startDate: null,
          endDate: null,
          sort: false,
        },
      };

    case ACTION_CONSTANTS.FILTER_RECORD_HISTORY:
      return {
        ...state,
        historyFilter: action.payload || {
          startDate: null,
          endDate: null,
        },
      };

    case ACTION_CONSTANTS.GET_RECORD_HISTORY_REQUESTED:
      return {
        ...state,
        isHistoryLoading: true,
        error: null,
      };

    case ACTION_CONSTANTS.GET_RECORD_HISTORY_SUCCESS:
      return {
        ...state,
        recordHistory: action.payload,
        isHistoryLoading: false,
        error: null,
      };

    case ACTION_CONSTANTS.GET_RECORD_HISTORY_FAILURE:
      return {
        ...state,
        isHistoryLoading: false,
        error: action.payload,
      };

    case ACTION_CONSTANTS.GET_RECORD_HISTORY_DETAILS_REQUESTED:
      return {
        ...state,
        isHistoryDetailsLoading: true,
        error: null,
      };

    case ACTION_CONSTANTS.GET_RECORD_HISTORY_DETAILS_SUCCESS:
      return {
        ...state,
        recordHistoryDetails: action.payload.feedlotRecordHistory,
        isHistoryDetailsLoading: false,
        error: null,
      };

    case ACTION_CONSTANTS.GET_RECORD_HISTORY_DETAILS_FAILURE:
      return {
        ...state,
        isHistoryDetailsLoading: false,
        error: action.payload,
      };

    case ACTION_CONSTANTS.ADD_RECORD_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
        error: null,
        success: false,
      };

    case ACTION_CONSTANTS.ADD_RECORD_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: true,
        error: null,
      };

    case ACTION_CONSTANTS.ADD_RECORD_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        success: false,
      };

    case ACTION_CONSTANTS.UPDATE_RECORD_REQUESTED:
      return {
        ...state,
        isUpdating: true,
        error: null,
        updateSuccess: false,
      };

    case ACTION_CONSTANTS.UPDATE_RECORD_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updateSuccess: true,
        error: null,
      };

    case ACTION_CONSTANTS.UPDATE_RECORD_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
        updateSuccess: false,
      };

    case ACTION_CONSTANTS.DELETE_RECORD_REQUESTED:
      return {
        ...state,
        isDeleting: true,
        error: null,
        deleteSuccess: false,
      };

    case ACTION_CONSTANTS.DELETE_RECORD_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        deleteSuccess: true,
        error: null,
      };

    case ACTION_CONSTANTS.DELETE_RECORD_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload,
        deleteSuccess: false,
      };

    case ACTION_CONSTANTS.UPLOAD_RECORD_ATTACHMENT_REQUESTED:
      return {
        ...state,
        attachmentUploads: {
          ...state.attachmentUploads,
          [action.payload.tempId]: { status: 'uploading' },
        },
      };

    case ACTION_CONSTANTS.UPLOAD_RECORD_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachmentUploads: {
          ...state.attachmentUploads,
          [action.payload.tempId]: {
            status: 'success',
            attachmentId: action.payload.attachmentId,
          },
        },
      };

    case ACTION_CONSTANTS.UPLOAD_RECORD_ATTACHMENT_FAILURE:
      return {
        ...state,
        attachmentUploads: {
          ...state.attachmentUploads,
          [action.payload.tempId]: {
            status: 'failure',
            error: action.payload.error,
          },
        },
      };

    case ACTION_CONSTANTS.CLEAR_RECORD_ATTACHMENT_UPLOAD: {
      const attachmentUploads = { ...state.attachmentUploads };
      delete attachmentUploads[action.payload.tempId];
      return { ...state, attachmentUploads };
    }

    case ACTION_CONSTANTS.CLEAR_ALL_RECORD_ATTACHMENT_UPLOADS:
      return { ...state, attachmentUploads: {} };

    default:
      return state;
  }
}
